import { FC, useEffect, useState } from "react";
import { Typography, Button, Box, Grid, Tooltip } from "@material-ui/core";
import { MyPortfolioProps } from "../../interfaces";
import ClaimTokenModal from "../Modals/ClaimTokenModal";

import ContributionRefundModal, {
  ContributionRefundPayload,
} from "../Modals/contribution/refund";
import useModal from "../../hooks/useModal";
import usePortfolioListItemStyles from "./styles";
import { UserInvestmentRefundSchema } from "../../constants/user-investment";
import { checkCanRefund } from "./service";
import { MdInfoOutline } from "react-icons/md";
import { useHistory } from "react-router";
import { FaRegHandPaper } from "react-icons/fa";

const MyPortfolioMobileList: FC<MyPortfolioProps> = (props) => {
  const classes = usePortfolioListItemStyles();
  const history = useHistory();
  const {
    poolId,
    claimModalActionProps,
    poolTgeDate,
    poolRefundPolicy,
    investmentRefundPayload,
    distributionScAddress,
    distributionStatusDescription,
    totalTokenClaimable,
    totalTokenClaimed,
    isExternalProject,
    code,
  } = props;

  const [openClaimTokenModal, setOpenClaimTokenModal] = useState(false);
  const [investmentRefund, setInvestmentRefund] = useState<
    UserInvestmentRefundSchema | undefined
  >(investmentRefundPayload);
  const [showClaimBtn, setShowClaimBtn] = useState<boolean>(
    true && !investmentRefundPayload?.status
  );
  const [canRefund, setCanRefund] = useState(() =>
    checkCanRefund({
      poolTgeDate,
      investmentRefundPayload,
      poolRefundPolicy,
    })
  );

  const [refundStartDate, setRefundStartDate] = useState<Date | null>(null);
  const [refundEndDate, setRefundEndDate] = useState<Date | null>(null);

  const [isRefundLive, setIsRefundLive] = useState(false);
  const [isRefundWindowExpired, setIsRefundWindowExpired] = useState(false);

  useEffect(() =>{
    if (props.poolTgeDate && props.poolRefundPolicy?.explicitRefundWindowInSeconds) {
      setRefundStartDate(new Date(props.poolTgeDate))
      setRefundEndDate(new Date(new Date(props.poolTgeDate).getTime() + props.poolRefundPolicy?.explicitRefundWindowInSeconds * 1000))
    }
  }, []);

  useEffect(() => {
    if (refundStartDate && refundEndDate) {
      const now = new Date();
      setIsRefundLive(now >= refundStartDate && now <= refundEndDate)
      setIsRefundWindowExpired(now > refundEndDate)
    }
  }, [refundStartDate, refundEndDate])

  const { status } = investmentRefund ?? {};

  const {
    close: closeRefundContributionModal,
    open: openRefundContributionModal,
    isOpen: isRefundContributionModalOpen,
    payload: refundContributionModalPayload,
  } = useModal();

  const handleOnRefund = () => {
    openRefundContributionModal(props);
  };

  const onRefundRequestSuccess = (result: UserInvestmentRefundSchema) => {
    setCanRefund(false);
    setShowClaimBtn(false);
    setInvestmentRefund(result);
  };

  const handleClaimTokenModal = () => {
    setOpenClaimTokenModal(true);
  };

  const isClaimable =
    props.distributionScAddress &&
    props.distributionScAddress.length > 0 &&
    props.distributionScAddress[0].isClaimable &&
    !status;

    const isClaimedDisabled: boolean = 
    !isClaimable ||
    (distributionScAddress && distributionScAddress[0].isAirdropped === true) ||
    (totalTokenClaimable !== undefined && totalTokenClaimable > 0 && 
     totalTokenClaimed !== undefined && totalTokenClaimed === totalTokenClaimable);

  const redirectToDetailPage = (event?: any) => {
    event?.preventDefault();
    history.push(`/project/${poolId}` + (isExternalProject ? `?code=${code}` : ""));
  }

  return (
    <>
      <Grid item sm={6} xs={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection="column"
          className="mobielViewMain"
          p={1}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            flexDirection="column"
            onClick={() => redirectToDetailPage()}
          >
            <Box
              display="flex"
              mb="12px"
              justifyContent="center"
              alignItems="center"
            >
              <Box display="flex" flexGrow="1" alignItems="center" overflow="hiddden">
                <img src={props.imgSrc} alt="" className="projectLogo" />
                <Typography variant="h6" color="secondary">
                  {props.title}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h6" color="primary">
                  {props.contr}
                </Typography>
                <Typography variant="subtitle1" className="textColor fw-normal">
                  Contribution
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              p={2}
              mb="6px"
              justifyContent="space-between"
              className="mobileContent"
            >
              <Box flexGrow="1">
                <Typography variant="subtitle1" className="textColor fw-normal">
                  Status
                </Typography>
              </Box>
              <Box className="mobileViewProgress">
                <Typography
                  align="right"
                  variant="subtitle1"
                  color="secondary"
                  className="fw-normal"
                >
                  {props.status.toUpperCase()}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              p={2}
              mb="6px"
              justifyContent="space-between"
              className="mobileContent"
            >
              <Box flexGrow="1">
                <Typography variant="subtitle1" className="textColor fw-normal">
                  Price ($)
                </Typography>
              </Box>
              <Box className="mobileViewProgress">
                <Typography align="right" variant="subtitle1" color="primary">
                  {props.price}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              p={2}
              mb="6px"
              justifyContent="space-between"
              className="mobileContent"
            >
              <Box flexGrow="1">
                <Typography variant="subtitle1" className="textColor fw-normal">
                  % Gain
                </Typography>
              </Box>
              <Box className="mobileViewProgress">
                <Typography align="right" variant="subtitle1" color="primary">
                {Number(props.percent) ? (props.percent > 0 ? "+" : "") + props.percent + "%" : "Not Listed"}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              p={2}
              mb="6px"
              justifyContent="space-between"
              className="mobileContent"
            >
              <Box flexGrow="1">
                <Typography variant="subtitle1" className="textColor fw-normal">
                  Tokens Received
                </Typography>
              </Box>
              <Box className="mobileViewProgress">
                <Typography align="right" variant="subtitle1" color="primary">
                  {props.tokenReceived}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              p={2}
              mb="6px"
              justifyContent="space-between"
              className="mobileContent"
            >
              <Box flexGrow="1">
                <Typography variant="subtitle1" className="textColor fw-normal">
                  Refundable
                </Typography>
              </Box>
              <Box className="mobileViewProgress">
                <Typography align="right" variant="subtitle1" color={ isRefundWindowExpired ? "error" : props.poolRefundPolicy?.refundable ? "primary" : "textPrimary"}>
                  { isRefundWindowExpired ? "Expired" : props.poolRefundPolicy?.refundable ? "YES" : "NO"}
                </Typography>
              </Box>
            </Box>

            {
              props.poolRefundPolicy?.refundable && (
                <>
                  <Box
                    display="flex"
                    p={2}
                    mb="6px"
                    justifyContent="space-between"
                    className="mobileContent"
                  >
                    <Box flexGrow="1">
                      <Typography variant="subtitle1" className="textColor fw-normal">
                        Refund Start Date:
                      </Typography>
                    </Box>
                    <Box className="mobileViewProgress">
                      <Typography align="right" variant="subtitle1" color={props.poolRefundPolicy?.refundable ? "primary" : "textPrimary"}>
                      {isRefundLive ? 'Live Now' : refundStartDate?.toUTCString
                  ()}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    p={2}
                    mb="6px"
                    justifyContent="space-between"
                    className="mobileContent"
                  >
                    <Box flexGrow="1">
                      <Typography variant="subtitle1" className="textColor fw-normal">
                        Refund End Date:
                      </Typography>
                    </Box>
                    <Box className="mobileViewProgress">
                      <Typography align="right" variant="subtitle1" color={ isRefundWindowExpired ? 'error' : 'primary'}>
                        {refundEndDate?.toUTCString()}
                      </Typography>
                    </Box>
                  </Box>
                </>
              )
            }
          </Box>

          <Box display="flex" mt={1}
            style={{
              gap: ".5rem",
            }}>
            {
              <>
                {showClaimBtn && (
                  <Button
                    disabled={isClaimedDisabled}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className=""
                    onClick={handleClaimTokenModal}
                  >
                    {distributionScAddress && distributionScAddress[0].isAirdropped ? "Airdropped" : "Claim"}
                  </Button>
                )}

                {canRefund && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={handleOnRefund}
                  >
                    <FaRegHandPaper />&nbsp;
                    Request Refund
                  </Button>
                )}

                {status === "requested" && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled
                  >
                    Pending refund
                  </Button>
                )}

                {status === "refunded" && (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled
                    className={classes.refunded_btn}
                  >
                    Refunded
                  </Button>
                )}
                {
                  distributionStatusDescription && (
                    <Tooltip title={distributionStatusDescription}>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <MdInfoOutline style={{ color: 'inherit' }} />
                      </span>
                    </Tooltip>
                  )
                }
                {openClaimTokenModal ? (
                  <ClaimTokenModal
                    open={openClaimTokenModal}
                    setOpen={setOpenClaimTokenModal}
                    poolId={props.poolId}
                    canRefund={canRefund}
                    modalActionProps={claimModalActionProps}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </Box>
        </Box>
      </Grid>
      <ContributionRefundModal
        onClose={closeRefundContributionModal}
        isOpen={isRefundContributionModalOpen}
        payload={refundContributionModalPayload as ContributionRefundPayload}
        onSuccess={onRefundRequestSuccess}
      />
    </>
  );
};

export default MyPortfolioMobileList;
